// Mock Data and Utilities for Worksheet Wizard
import type { LaborNorm, Part, Product } from './types';

// Mock parts inventory (no backend endpoint for service-parts yet)
export const MOCK_PARTS: Part[] = [
  {
    id: 'part1',
    name: 'Szénkefe készlet (2db)',
    sku: 'MK-CB-001',
    unitPrice: 2500,
    inStock: 45,
    category: 'Elektromos',
  },
  {
    id: 'part2',
    name: 'O-gyűrű készlet',
    sku: 'MK-OR-002',
    unitPrice: 1200,
    inStock: 120,
    category: 'Tömítés',
  },
  {
    id: 'part3',
    name: 'Ütvető dugattyú',
    sku: 'MK-HP-003',
    unitPrice: 8500,
    inStock: 12,
    category: 'Mechanika',
  },
  {
    id: 'part4',
    name: 'Kapcsoló modul',
    sku: 'MK-SW-004',
    unitPrice: 4800,
    inStock: 28,
    category: 'Elektromos',
  },
  {
    id: 'part5',
    name: 'Tokmány SDS-Plus',
    sku: 'GEN-CH-005',
    unitPrice: 12500,
    inStock: 8,
    category: 'Tartozék',
  },
  {
    id: 'part6',
    name: 'Kábel 3m H07RN-F',
    sku: 'GEN-CB-006',
    unitPrice: 3200,
    inStock: 35,
    category: 'Elektromos',
  },
  {
    id: 'part7',
    name: 'Csapágy készlet 608ZZ',
    sku: 'GEN-BR-007',
    unitPrice: 1800,
    inStock: 65,
    category: 'Mechanika',
  },
  {
    id: 'part8',
    name: 'Fogaskerék hajtómű',
    sku: 'MK-GR-008',
    unitPrice: 15200,
    inStock: 5,
    category: 'Mechanika',
  },
  {
    id: 'part9',
    name: 'Láncfűrész lánc 35cm',
    sku: 'STL-CH-009',
    unitPrice: 6800,
    inStock: 22,
    category: 'Tartozék',
  },
  {
    id: 'part10',
    name: 'Légszűrő',
    sku: 'GEN-AF-010',
    unitPrice: 2100,
    inStock: 40,
    category: 'Szűrő',
  },
];

// Helper: Check if product is under warranty
export function isUnderWarranty(product: Product): boolean {
  if (!product.warrantyExpiry) return false;
  return new Date() < product.warrantyExpiry;
}

// Helper: Calculate item totals
export function calculateItemTotal(
  unitPrice: number,
  quantity: number,
  vatRate: number = 27
): {
  netAmount: number;
  grossAmount: number;
} {
  const netAmount = unitPrice * quantity;
  const grossAmount = Math.round(netAmount * (1 + vatRate / 100));
  return { netAmount, grossAmount };
}

// Helper: Calculate labor price from norm
export function calculateLaborPrice(norm: LaborNorm, quantity: number = 1): number {
  return Math.round((norm.minutes / 60) * norm.hourlyRate * quantity);
}
